import { Subject } from "rxjs"
import type * as React from 'react'

export interface FlashParams {
  content: React.ReactNode | React.ReactNode[]
  type: 'alert' | 'error' | 'warning' | 'success'
  fixed?: boolean
  durationSeconds?: number
}

export const flash$ = new Subject<FlashParams>()